"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONMarshallerImpl = void 0;
var void_1 = require("./void");
var JSONMarshallerImpl = (function () {
    function JSONMarshallerImpl(pretty) {
        if (pretty === void 0) { pretty = false; }
        this.pretty = pretty;
    }
    JSONMarshallerImpl.prototype.Marshal = function (data, toRaw) {
        if (data instanceof void_1.Void) {
            return toRaw ? {} : '{}';
        }
        var dataAny = data;
        var serialized = typeof dataAny['serialize'] === 'function' ? dataAny['serialize']() : data;
        if (toRaw) {
            return serialized;
        }
        if (this.pretty) {
            return JSON.stringify(serialized, null, 4);
        }
        else {
            return JSON.stringify(serialized);
        }
    };
    JSONMarshallerImpl.prototype.Unmarshal = function (data, fromRaw) {
        if (fromRaw) {
            return data;
        }
        return JSON.parse(data);
    };
    return JSONMarshallerImpl;
}());
exports.JSONMarshallerImpl = JSONMarshallerImpl;
//# sourceMappingURL=marshaller.js.map